import dayjs from 'dayjs'
import React from 'react'
import { ReportsTableItem } from '../../styledComponents'
import { renderFeeRelatedDataForClinicReport } from '../ClinicReportComponent'

export default function BrandPatientFeeCollectedReport({
  metricData,
  reportEndTime,
  reportStartTime,
  getCorrectReportDateString,
  allClinicLocations,
}) {
  const allColumnsLength = 1 + (allClinicLocations?.length || 0)

  return (
    <ReportsTableItem columns={allColumnsLength}>
      <div className="reports-top-header">
        {reportEndTime &&
          getCorrectReportDateString(
            dayjs.utc(reportEndTime).local(),
            dayjs.utc(reportStartTime).local(),
          )}
      </div>
      {renderFeeRelatedDataForClinicReport(metricData?.currencyToFeeCollectedMap)}
      {allClinicLocations?.map((clnLoc) => {
        return (
          <React.Fragment key={`fee-${clnLoc?.id}`}>
            {renderFeeRelatedDataForClinicReport(
              metricData?.[`${clnLoc?.id}__currencyToFeeCollectedMap`],
            )}
          </React.Fragment>
        )
      })}
    </ReportsTableItem>
  )
}
